// Teclado dentro dos popups de produto (pedido do dono, 30/09/2026) — Balcão,
// Mesas e Delivery usam os mesmos atalhos em cada etapa. O popup só marca os
// elementos:
//   data-opcao (+ data-escolhida="1" quando marcado) — cada item escolhível
//   data-avancar — Próxima etapa / Revisar pedido / Adicionar
//   data-voltar  — a seta de voltar etapa
//   data-busca-opcao — a caixa "Buscar opção..." (as setas saem dela para a lista)
//   data-foco-inicial — o campo que recebe o cursor ao abrir (peso por quilo)
// Teclas:
//   Tab / → / ↓ = próximo item · Shift+Tab / ← / ↑ = anterior (o foco anda nos itens)
//   Enter = escolhe o item em foco; num item já escolhido (ou fora da lista), avança
//   Espaço = marca/desmarca o item em foco (o normal de um botão)
//   Esc = volta uma etapa; sem "voltar", o popup fecha como sempre
// Em campo de texto (observação, peso digitado) as teclas continuam do campo.
const MOVE = { Tab: 1, ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };

function opcoesDe(caixa) {
  return [...caixa.querySelectorAll("[data-opcao]")].filter((el) => !el.disabled && el.offsetParent !== null);
}

function focar(el) {
  if (!el) return;
  el.focus();
  el.scrollIntoView?.({ block: "nearest" });
}

function campoDeTexto(el) {
  if (!el) return false;
  if (el.tagName === "TEXTAREA" || el.tagName === "SELECT") return true;
  return el.tagName === "INPUT" && !el.closest("[data-busca-opcao]");
}

export function focarInicial(caixa) {
  if (!caixa) return;
  // Campo marcado para receber o cursor ao abrir (peso do produto por quilo
  // no Balcão, 30/09/2026) vem antes dos itens e do Adicionar.
  const campo = caixa.querySelector("[data-foco-inicial]");
  if (campo) { campo.focus(); return; }
  const opcoes = opcoesDe(caixa);
  focar(opcoes.find((el) => el.dataset.escolhida === "1") || opcoes[0] || caixa.querySelector("[data-avancar]:not([disabled])"));
}

/** Props para o <DialogContent> do popup: onKeyDown, onEscapeKeyDown, onOpenAutoFocus. */
export function tecladoPopupProduto() {
  return {
    onOpenAutoFocus: (e) => {
      e.preventDefault();
      const caixa = e.target;
      setTimeout(() => focarInicial(caixa), 0);
    },
    onEscapeKeyDown: (e) => {
      const caixa = e.target?.closest?.('[role="dialog"]');
      const voltar = caixa?.querySelector("[data-voltar]");
      if (voltar) { e.preventDefault(); voltar.click(); }
    },
    onKeyDown: (e) => {
      if (e.ctrlKey || e.altKey || e.metaKey || e.defaultPrevented) return;
      const caixa = e.currentTarget;
      const alvo = e.target;
      if (e.key in MOVE) {
        if (campoDeTexto(alvo)) return;
        const opcoes = opcoesDe(caixa);
        if (!opcoes.length) return;
        const passo = e.key === "Tab" && e.shiftKey ? -1 : MOVE[e.key];
        const atual = opcoes.indexOf(alvo.closest?.("[data-opcao]"));
        const prox = atual < 0 ? (passo > 0 ? 0 : opcoes.length - 1) : (atual + passo + opcoes.length) % opcoes.length;
        e.preventDefault();
        focar(opcoes[prox]);
        return;
      }
      if (e.key !== "Enter" || campoDeTexto(alvo)) return;
      const opcao = alvo.closest?.("[data-opcao]");
      if (opcao && opcao.dataset.escolhida !== "1") { e.preventDefault(); opcao.click(); return; }
      // Enter num outro botão em foco (X, voltar, "Alterar") é do próprio botão.
      if (!opcao && alvo.tagName === "BUTTON") return;
      const avancar = caixa.querySelector("[data-avancar]:not([disabled])");
      if (avancar) { e.preventDefault(); avancar.click(); setTimeout(() => focarInicial(caixa), 50); return; }
      const opcoes = opcoesDe(caixa);
      if (!opcao && opcoes.length) { e.preventDefault(); focar(opcoes[0]); }
    },
  };
}

// Classes do anel de foco dos itens (o teclado precisa mostrar onde está).
export const ANEL_FOCO = "focus:outline-none focus-visible:ring-4 focus-visible:ring-orange-500/60";
